import { useConfirmDialog } from '@ztechapps/common.hook'
import { BusyButtonLink } from '@ztechapps/webui.button'
import React from 'react'
import { useTableContext } from '../Context'

export const ResetFilter = () => {
  const { onResetFilter } = useTableContext()
  const { onConfirm } = useConfirmDialog({
    title: 'Reset Table Filters & Sorting',
    text: 'This will reset the active table filters, sorting, and return to page 1.',
    buttons: {
      confirm: {
        text: 'Yes, reset it!',
      },
    },
    confirmed: onResetFilter,
  })

  return <BusyButtonLink bsSize="sm" text="Reset Filters" onClick={onConfirm} />
}
